<script setup lang="ts">
import { ref, watch } from 'vue';

import type { FileContent } from '@/types/file';
import { downloadFileFromPath } from '@/utils/file';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps<{
    fileOrDirectory: FileContent;
    organizationId: string;
}>();

const isOpen = ref(false);
const isDirectory = ref(getIsDirectory());

function toggleOpen(): void {
    isOpen.value = !isOpen.value;
}

function getIsDirectory(): boolean {
    return props.fileOrDirectory.type == 'directory';
}

async function openFile(): Promise<void> {
    await router.push(props.fileOrDirectory.path);
}

function getItemIcon(): string {
    if (isDirectory.value) {
        return isOpen.value ? 'folder_open' : 'folder';
    } else {
        return 'description';
    }
}

watch(
    () => props.fileOrDirectory,
    () => {
        isDirectory.value = getIsDirectory();
    }
);
</script>

<template>
    <div>
        <li
            class="directory-item cursor-pointer"
            @click="isDirectory ? toggleOpen() : openFile()"
            :title="isDirectory && !isOpen ? 'Map openklappen' : isDirectory && isOpen ? 'Map dichtklappen' : ''"
        >
            <v-row dense align="center" class="my-0 py-3 px-3">
                <v-icon :icon="getItemIcon()" :class="isDirectory ? 'text-alt-darker' : 'text-main'" />
                <span>{{ props.fileOrDirectory.name }}</span>
                <v-spacer />
                <v-btn
                    style="min-width: 15px !important"
                    class="px-3"
                    variant="flat"
                    color="primary"
                    v-if="!isDirectory"
                    @click.stop="downloadFileFromPath(props.organizationId, fileOrDirectory.path)"
                    title="Document downloaden"
                >
                    <v-icon size="26">download</v-icon>
                </v-btn>
            </v-row>
        </li>
        <ul v-if="isDirectory && isOpen" class="sub-items-container">
            <DirectoryItem
                v-for="(child, index) in fileOrDirectory.children"
                :key="index"
                :fileOrDirectory="child"
                :organizationId="props.organizationId"
            />
        </ul>
    </div>
</template>

<style scoped>
.directory-item i {
    font-size: 30px;
}

.sub-items-container {
    list-style-type: none;
}
</style>
